"use client";

import { useSyncExternalStore } from "react";

/** The value never changes after hydration, so there is nothing to subscribe to. */
const subscribe = () => () => {};

/**
 * Returns false while rendering on the server and during the hydration pass,
 * then true on the client.
 *
 * Use this for content that must not differ between the server markup and the
 * first client render, such as anything derived from the resolved theme or the
 * viewport. It replaces the useState/useEffect "mounted" flag, which sets state
 * synchronously in an effect and costs an extra render pass.
 */
export function useHydrated() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
